import React, { useState } from "react";
import InputBrand from "../Form/QuickAdding/InputBrand";
import { Button } from "controls";
import { action, API, controller } from "api";
import { ToFormData } from "hooks";
import { toast } from "react-toastify";

const UpdateBrand = ({ selectedRec, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({ brandId: "" });

  const handleInpChg = (e) => {
    setValues({ brandId: e.target.value });
  };

  const handleSubmit = () => {
    setLoading(true);
    API(controller.Product + action.UpdateBCST).post(
      ToFormData({
        all: selectedRec?.all,
        ids: selectedRec?.items,
        type: "brand",
        brandId: values.brandId,
      }),
      (res) => {
        if (res?.status === 200) toast.success(res.msg);
        setLoading(false);
        handleClose();
      }
    );
  };

  return (
    <div className="pt-4 flex flex-col gap-5">
      <InputBrand {...{ handleInpChg, values, setValues }} size="large" />

      <div className="flex justify-end gap-2">
        <Button
          variant="text"
          size="large"
          className="!min-w-[130px]"
          onClick={handleClose}
        >
          Don't Update
        </Button>
        <Button size="large" loading={loading} onClick={handleSubmit}>
          Update Brand
        </Button>
      </div>
    </div>
  );
};

export default UpdateBrand;
